import { isAuthenticated, login_function } from "../../requests/api_request";
import { useNavigate } from "react-router-dom";
import { Button, Form, Input } from "antd";
import { useEffect, useState } from "react";

export default function Login() {
  const navigate = useNavigate();
  const [Auth, setAuth] = useState();
  const [error, setError] = useState("");

  useEffect(() => {
    const Auth_checker = async () => {
      setAuth(await isAuthenticated());
    };
    Auth_checker();
  }, []);

  if (Auth) {
    navigate("/?status=all");
    window.location.reload();
  }

  return (
    <div className="w-full flex justify-center rounded-sm mt-[30%] lg:mt-[10%]">
      <div className=" bg-[#1047AE] hidden lg:grid w-[20%] h-full pb-[5%]">
        <img
          className=" mt-[10%] m-auto h-[200px] w-[200px] "
          src="/login_eodb.png"
        />

        <div className=" text-white px-[10%] text-justify mt-[5%] m-auto">
          <h1 className=" mb-[3%] text-[27px] text-center">
            Welcome to Business portal{" "}
          </h1>
          The national business portal is a one-stop portal for e-government
          services that improves ease of doing business in Ethiopia through the
          automation.
        </div>
      </div>
      <Form
        className=" w-[70%] md:w-[35%] bg-white p-[4%]"
        layout="vertical"
        onFinish={async (values) => {
          const check = await login_function(values.email, values.password);
          if (check.error) {
            setError(check.message);
          } else {
            navigate("/?status=pending");
            window.location.reload();
          }
        }}
      >
        <h1 className=" mb-[5%] text-[40px] font-bold text-center">Sign In</h1>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              message: "*Please enter your Email",
            },
          ]}
        >
          <Input className="h-12" placeholder="Enter your email" />
        </Form.Item>
        <Form.Item
          label="Password"
          name="password"
          rules={[
            {
              required: true,
              message: "*Please enter your Password",
            },
          ]}
        >
          <Input.Password
            className="h-12"
            type="password"
            placeholder="Enter your password"
          />
        </Form.Item>
        {error && <p className=" text-red-500">{error}</p>}

        <Button
          className=" bg-login_btn text-white mt-2 h-12 w-full"
          htmlType="submit"
        >
          Login
        </Button>
      </Form>
    </div>
  );
}
